import script from "./inputComboBox2.vue?vue&type=script&setup=true&lang=ts"
export * from "./inputComboBox2.vue?vue&type=script&setup=true&lang=ts"

import "./inputComboBox2.vue?vue&type=style&index=0&id=1e770143&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e770143"]])

export default __exports__